export default __webpack_public_path__ + "static/media/guest_19_01.66647d3d.png";